import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
  Output,
  EventEmitter,
  AfterViewInit,
} from "@angular/core";
import {
  DefaultMatCalendarRangeStrategy,
  MatCalendar,
  MatCalendarCellClassFunction,
  MatRangeDateSelectionModel,
  MAT_DATE_RANGE_SELECTION_STRATEGY,
  MatDatepickerModule,
} from "@angular/material/datepicker";
import { CommonModule } from "@angular/common";
import { IconComponent } from "../icon/icon.component";
import * as moment from 'moment';
import { Moment } from "moment";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MAT_NATIVE_DATE_FORMATS, NativeDateAdapter } from "@angular/material/core";

@Component({
  selector: "mg-calendar-date",
  templateUrl: "./calendar-date.component.html",
  styleUrls: ["./calendar-date.component.scss"],
  providers: [
    {
      provide: MAT_DATE_RANGE_SELECTION_STRATEGY,
      useClass: DefaultMatCalendarRangeStrategy,
    },
    DefaultMatCalendarRangeStrategy,
    MatRangeDateSelectionModel,
    { provide: DateAdapter, useClass: NativeDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_NATIVE_DATE_FORMATS },
  ],
  standalone: true,
  imports: [CommonModule, MatDatepickerModule, IconComponent],
})
export class CalendarDateComponent implements OnChanges, AfterViewInit {
  @Input() selectedDate: Date | null = null;

  @Input() min: Date = new Date();
  @Input() max: Date | null = null;
  @Input() reset: boolean = false;
  @Input() activeMonth: Date | null = null; // Nuevo: controla el mes activo del calendario

  //classes to dates
  @Input() serie1: string[] = [];
  @Input() cssSerie1: string = "";
  @Input() iconSerie1: string = "";
  @Input() titleSerie1: string = "";

  @Input() serie2: string[] = [];
  @Input() cssSerie2: string = "";
  @Input() iconSerie2: string = "";
  @Input() titleSerie2: string = "";

  @Input() serie3: string[] = [];
  @Input() cssSerie3: string = "";
  @Input() iconSerie3: string = "";
  @Input() titleSerie3: string = "";

  @Input() serie4: string[] = [];
  @Input() cssSerie4: string = "";
  @Input() iconSerie4: string = "";
  @Input() titleSerie4: string = "";

  @Input() serie5: string[] = [];
  @Input() cssSerie5: string = "";
  @Input() iconSerie5: string = "";
  @Input() titleSerie5: string = "";

  //filters to disable dates
  @Input() aDisabledDays: string[] = [];
  @Input() aDisabledDaysByDayOfWeek: number[] = [];
  @Input() dateFilter: ((d: Date | null) => boolean) | null = null;
  
  @ViewChild(MatCalendar) calendar: MatCalendar<Date>;
  @Output() selectDate = new EventEmitter<any>();
  @Output() calendarDate = new EventEmitter<any>();

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['min'] ||
      changes['max'] ||
      changes['serie1'] ||
      changes['serie2'] ||
      changes['serie3'] ||
      changes['serie4'] ||
      changes['serie5'] ||
      changes['aDisabledDays'] ||
      changes['aDisabledDaysByDayOfWeek']
    ) {
      this.someEvent();
    }

    if (changes['reset']) {
      this.resetDates();
    }

    // Detectar cambio en el mes activo
    if (changes['activeMonth'] && this.activeMonth) {
      this.selectedDate = null;
      setTimeout(() => {
        this.updateActiveMonth(this.activeMonth!);
      }, 50);
    }
  }

  ngAfterViewInit() {
    if (this.activeMonth) {
      setTimeout(() => this.updateActiveMonth(this.activeMonth!), 0);
    }
    this.calendarDate.emit(this.calendar.activeDate);
  }

  someEvent() {
    if (this.calendar) this.calendar.updateTodaysDate();
  }

  resetDates() {
    this.selectedDate = null;
    this.selectDate.emit(this.selectedDate);
  }

  /**
   * Actualiza el mes activo del calendario
   * @param date Nueva fecha para el mes activo
   */
  updateActiveMonth(date: Date): void {
    if (this.calendar) {
      try {
        const targetDate = new Date(date.getFullYear(), date.getMonth(), 1);
        (this.calendar as any)._goToDateInView(targetDate, 'month');
      } catch (error) {
        // Silencioso - los dos calendarios separados manejan esto automáticamente
      }
    }
  }

  dateClass: MatCalendarCellClassFunction<Date> = (cellDate, view) => {
    let newDate = moment(cellDate).format("YYYY-MM-DD");
   
    if (view === "month") {
      return this.searchDateInSeries(newDate);
    }
    return "";
  };

  searchDateInSeries(dateToSearch: string) {
    if (this.serie1.length && this.serie1.includes(dateToSearch)) {
      return this.cssSerie1;
    }

    if (this.serie2.length && this.serie2.includes(dateToSearch)) {
      return this.cssSerie2;
    }

    if (this.serie3.length && this.serie3.includes(dateToSearch)) {
      return this.cssSerie3;
    }

    if (this.serie4.length && this.serie4.includes(dateToSearch)) {
      return this.cssSerie4;
    }

    if (this.serie5 && this.serie5.includes(dateToSearch)) {
      return this.cssSerie5;
    }

    return "";
  }

  filters = (d: Date | null): boolean => {
    if (d != null) {
      // Block dates before explicit min
      if (this.min) {
        const minMoment = moment(this.min).startOf('day');
        const dMoment = moment(d).startOf('day');
        if (dMoment.isBefore(minMoment)) {
          return false;
        }
      }
      // apply external dateFilter first if provided
      if (this.dateFilter && !this.dateFilter(d)) {
        return false;
      }
      let newDate = moment(d);
      return this.searchDisabled(newDate);
    }
    return true;
  };

  searchDisabled(newDate: Moment) {
    if (
      this.aDisabledDays.length &&
      this.aDisabledDays.includes(newDate.format("YYYY-MM-DD"))
    ) {
      return false;
    }

    if (
      this.aDisabledDaysByDayOfWeek.length &&
      this.aDisabledDaysByDayOfWeek.includes(newDate.day())
    ) {
      return false;
    }

    return true;
  }

  dateChanged(date: Date): void {
    this.selectDate.emit(date);
  }
}
